var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowRightIcon, Button, ChevronLeftIcon, ClipboardIcon, EyeOpenIcon, Heading, IconButton, InfoSignIcon, Pane, Paragraph, Switch, TagInput, TextInput, ThemeProvider, toaster, Tooltip, } from 'evergreen-ui';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import React, { useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { useHistory } from 'react-router-dom';
import ApoTextInput from '../components/ApoTextInput';
import DurationField from '../components/DurationField';
import Relay from '../components/Relay/relay';
import ShopApothekeModal from '../components/shopApotheke/ShopApothekeModal';
import { useShopApotheke } from '../components/shopApotheke/store';
import firebase from '../config';
import NavigatorBar from '../container/NavigatorBar';
import { UserContext } from '../contexts/UserContext';
import { usePlan } from '../hooks/usePlan';
import theme from '../theme';
var UpgradeButton = function (_a) {
    var onClick = _a.onClick;
    return (_jsxs(Pane, __assign({ style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '1rem',
        } }, { children: [_jsxs(Pane, __assign({ style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                } }, { children: [_jsx(Button, __assign({ disabled: true }, { children: "Liefernachverfolgungs-Link" })), _jsx(Paragraph, __assign({ marginLeft: 8 }, { children: "im Plus oder Pro-Plan verf\u00FCgbar" }))] })), _jsx(Button, __assign({ size: "small", appearance: "primary", backgroundColor: '#2D3B51', onClick: function () { return (window.location.href = '/upgrade'); } }, { children: "Jetzt Upgraden" }))] })));
};
export var SettingsSection = function (_a) {
    var heading = _a.heading, description = _a.description, children = _a.children;
    return (_jsxs(Pane, __assign({ style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            margin: 20,
        } }, { children: [_jsx(Heading, __assign({ marginBottom: 5, className: "heading" }, { children: heading })), _jsx(Pane, __assign({ style: {
                    display: 'flex',
                    flexDirection: 'row',
                } }, { children: _jsx(Paragraph, __assign({ marginBottom: 5 }, { children: description })) })), _jsx(Pane, __assign({ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 8 }, { children: children }))] })));
};
export default function Routing() {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var history = useHistory();
    var _f = useContext(UserContext), user = _f.user, ready = _f.ready;
    var isUser = user[0];
    var _g = useState((_a = isUser.latestOrderTime) !== null && _a !== void 0 ? _a : '23:59'), latestOrderTime = _g[0], setLatestOrderTime = _g[1];
    var _h = React.useState((_b = isUser.tags) !== null && _b !== void 0 ? _b : []), tags = _h[0], setTags = _h[1];
    var _j = useState(isUser === null || isUser === void 0 ? void 0 : isUser.trackingNotifications), trackingEnabled = _j[0], setTrackingEnabled = _j[1];
    var _k = useState((_c = isUser === null || isUser === void 0 ? void 0 : isUser.motionToolsApiKey) !== null && _c !== void 0 ? _c : ''), motionToolsApiKey = _k[0], setMotionToolsApiKey = _k[1];
    var _l = useState(false), showMotionToolsApiKey = _l[0], setShowMotionToolsApiKey = _l[1];
    var _m = useState(isUser === null || isUser === void 0 ? void 0 : isUser.prioPosLabels), prioPosLabels = _m[0], setPrioPosLables = _m[1];
    var _o = useState(isUser === null || isUser === void 0 ? void 0 : isUser.dynamicPrios), dynamicPrios = _o[0], setDynamicPrios = _o[1];
    var _p = useState((_d = isUser === null || isUser === void 0 ? void 0 : isUser.processTime) !== null && _d !== void 0 ? _d : 4), processTime = _p[0], setProcessTime = _p[1];
    var _q = useState((_e = isUser === null || isUser === void 0 ? void 0 : isUser.bikeDistance) !== null && _e !== void 0 ? _e : 15), bikeDistance = _q[0], setBikeDistance = _q[1];
    var _r = useState(false), registerLoading = _r[0], setRegisterLoading = _r[1];
    var includedPharmacies = [
        'oxOIGit1FxOwiFEDZp0gy6TQbYi2',
        'U0UQt7ca29RmbqLYhaUArCWTX0P2',
        'dWZkGlqYORMPofoumG7PKPh4qvG3',
        'uEPpWY2CqDcuY3pNvHtRrNhD11U2',
        'Mtfyu7jxLOczz027jP6SmpjAXRY2',
        'Ai41rpTV2bWti1fH68pYrq6AFRe2',
        'Es7wK8vPFNQmZ4QJxQ4IB5crxyN2',
        '9vWKIH6WRDWoUQH2FmQE4dMkfMI2',
        '9vR3vHJUwJgX56TKvc1XfzUKnUq1',
    ];
    var plan = usePlan();
    var _s = useShopApotheke(), modalShown = _s.modalShown, setModal = _s.setModal;
    var _t = useState(false), isGlsInput = _t[0], setIsGlsInput = _t[1];
    var _u = useState(''), glsContactId = _u[0], setGlsContactId = _u[1];
    var registerLocations = function () {
        setRegisterLoading(true);
        var call = firebase
            .app()
            .functions('europe-west3')
            .httpsCallable('createLocationsAsSavedPlace');
        call()
            .then(function () { return toaster.success('Standorte erfolgreich registirert'); })
            .catch(function (err) {
            return toaster.danger('Standorte konnten nicht registiert werden');
        })
            .finally(function () { return setRegisterLoading(false); });
    };
    var updateLatestOrderTime = useCallback(function () {
        firebase
            .firestore()
            .collection('users')
            .doc(firebase.auth().currentUser.uid)
            .update({
            latestOrderTime: latestOrderTime,
        })
            .then(function () {
            toaster.success('Ihre Lieferzeitdaten wurden aktualisiert!');
        })
            .catch(function (err) {
            console.log(err);
            toaster.danger('Ihre Lieferzeitdaten konnten nicht aktualisiert werden!');
        });
    }, [latestOrderTime]);
    useEffect(function () {
        if (latestOrderTime !== isUser.latestOrderTime) {
            updateLatestOrderTime();
        }
    }, [isUser.latestOrderTime, latestOrderTime, updateLatestOrderTime]);
    useEffect(function () {
        if (trackingEnabled === null || trackingEnabled === undefined)
            return;
        firebase
            .firestore()
            .collection('users')
            .doc(firebase.auth().currentUser.uid)
            .update({
            trackingNotifications: trackingEnabled,
        })
            .then(function () { })
            .catch(function (err) {
            console.log(err);
        });
    }, [trackingEnabled]);
    useEffect(function () {
        if (prioPosLabels === null || prioPosLabels === undefined)
            return;
        firebase
            .firestore()
            .collection('users')
            .doc(firebase.auth().currentUser.uid)
            .update({
            prioPosLabels: prioPosLabels,
        })
            .then(function () { })
            .catch(function (err) {
            console.log(err);
        });
    }, [prioPosLabels]);
    useEffect(function () {
        if (dynamicPrios === null || dynamicPrios === undefined)
            return;
        firebase
            .firestore()
            .collection('users')
            .doc(firebase.auth().currentUser.uid)
            .update({
            dynamicPrios: dynamicPrios,
        })
            .then(function () { })
            .catch(function (err) {
            console.log(err);
        });
    }, [dynamicPrios]);
    useEffect(function () {
        if (processTime === null || processTime === undefined)
            return;
        firebase
            .firestore()
            .collection('users')
            .doc(firebase.auth().currentUser.uid)
            .update({
            processTime: processTime,
        })
            .then(function () { })
            .catch(function (err) {
            console.log(err);
        });
    }, [processTime]);
    useEffect(function () {
        if (bikeDistance === null || bikeDistance === undefined)
            return;
        firebase
            .firestore()
            .collection('users')
            .doc(firebase.auth().currentUser.uid)
            .update({
            bikeDistance: bikeDistance,
        })
            .then(function () { })
            .catch(function (err) {
            console.log(err);
        });
    }, [bikeDistance]);
    var changeTags = function (value) {
        var beforeValue = tags;
        setTags(value);
        firebase
            .firestore()
            .collection('users')
            .doc(firebase.auth().currentUser.uid)
            .update({ tags: value })
            .then(function () {
            setTags(value);
        })
            .catch(function (err) {
            setTags(beforeValue);
            console.log(err);
        });
    };
    var handleTrackOrder = function () {
        window.open("https://tracking.apomap.de/".concat(isUser.uid), '_blank', 'noopener,noreferrer');
    };
    var handleGlsCredentials = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.firestore().collection('users').doc(isUser.uid).update({
                        glsContactId: glsContactId,
                    })];
                case 1:
                    _a.sent();
                    toaster.success('GLS Kontaktdaten wurden aktualisiert!');
                    setGlsContactId('');
                    setIsGlsInput(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var saveMotionToolsApiKey = function () {
        firebase
            .firestore()
            .collection('users')
            .doc(firebase.auth().currentUser.uid)
            .update({
            motionToolsApiKey: motionToolsApiKey === '' ? null : motionToolsApiKey,
        })
            .then(function () {
            toaster.success('MotionTools API Key wurde erfolgreich hinterlegt');
        })
            .catch(function (err) {
            console.log(err);
            toaster.warning('Ein Fehler ist unterlaufen');
        });
    };
    var userPlan = useMemo(function () { return plan === null || plan === void 0 ? void 0 : plan.subscriptionLabel; }, [plan === null || plan === void 0 ? void 0 : plan.subscriptionLabel]);
    return (_jsx(ThemeProvider, __assign({ value: theme }, { children: _jsxs(Pane, __assign({ style: {
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                background: 'linear-gradient(-3deg,#E4EBF5 0%, rgba(255,255,255,1) 100%)',
            } }, { children: [_jsx(NavigatorBar, {}), _jsxs(Pane, __assign({ style: {
                        padding: 25,
                        margin: 25,
                        width: '100vw',
                        overflow: 'scroll',
                    } }, { children: [_jsxs(Pane, __assign({ maxWidth: "50vw" }, { children: [_jsx(Button, __assign({ onClick: function () { return history.push('/settings'); }, marginY: 8, marginRight: 12, iconBefore: ChevronLeftIcon }, { children: "Zur\u00FCck" })), _jsx(Heading, __assign({ size: 900 }, { children: "Prozesseinstellungen" })), _jsxs(SettingsSection, __assign({ heading: "Sp\u00E4teste Bestellzeit", description: "Wenn Auftr\u00E4ge ohne Lieferzeit vor dieser Uhrzeit eintreffen,\n                  werden sie am akutellen Tag ausgeliefert, ansonsten am\n                  n\u00E4chsten Tag." }, { children: [_jsx(ApoTextInput, { value: latestOrderTime, type: 'time', onChange: function (e) { return setLatestOrderTime(e.target.value); } }), _jsx(Tooltip, __assign({ content: "Auftr\u00E4ge, die ohne Lieferfenster \u00FCbertragen worden sind, werden vor der hier eingestellten Uhrzeit noch an dem heutigen Tag ausgeliefert. Wird ein Auftrag (ohne Lieferfenster) nach der hier angegeben Uhrzeit \u00FCber die Schnittstelle \u00FCbertragen, so wird er auf den Folgetag gelegt und dann erst ausgefahren. Wenn keine Uhrzeit angegeben ist, wird 12:00 Uhr als Zeit genommen." }, { children: _jsx(InfoSignIcon, { marginLeft: 5 }) }))] })), _jsx(SettingsSection, __assign({ heading: "Tags", description: "Tags k\u00F6nnen Auftr\u00E4gen vergeben werden. Diese helfen bei der\n                  Suche und der internen Organisation" }, { children: _jsx(TagInput, { values: tags, onChange: changeTags, inputProps: { placeholder: 'Tag anlegen...' } }) })), _jsx(SettingsSection, __assign({ heading: "E-Mail Benachrichtigungen", description: "Sollen deinen Kunden bei Eingang eines Auftrages eine E-Mail\n                  zugesendet werden? In dem, in der E-Mail enthaltenen Link,\n                  kann der Kunden den Status seiner Lieferung pr\u00FCfen." }, { children: _jsx(Pane, { children: userPlan === 'apomap-lite' ? (_jsx(UpgradeButton, {})) : (_jsxs(_Fragment, { children: [_jsx(Switch, { checked: trackingEnabled, onChange: function (e) { return setTrackingEnabled(e.target.checked); } }), _jsx(Paragraph, __assign({ marginLeft: 8 }, { children: trackingEnabled ? 'Aktiviert' : 'Deaktiviert' }))] })) }) })), _jsx(SettingsSection, __assign({ heading: "Whatsapp Benachrichtigungen", description: "Mit den Whatsapp-Integrationen k\u00F6nnen Sie die Sendungsnachverfolgung per Whatsapp an ihre Kunden versenden" }, { children: _jsx(Button, __assign({ onClick: function () { return (window.location.href = '/chat-integrations'); }, iconAfter: ArrowRightIcon }, { children: "Zu den Chat-Integrationen" })) })), _jsxs(SettingsSection, __assign({ heading: "Dynamische Priorisierung", description: "Abh\u00E4ngig von Attributen wie Zeitfenstern, Labels und\n                  Priorit\u00E4tsanwahl, werden den Auftr\u00E4gen bei der\n                  Routenoptimierung unterschiedliche Werte zugeordnet." }, { children: [_jsx(Switch, { checked: dynamicPrios, onChange: function (e) { return setDynamicPrios(e.target.checked); } }), _jsx(Paragraph, __assign({ marginLeft: 8 }, { children: dynamicPrios ? 'Aktiviert' : 'Deaktiviert' }))] })), dynamicPrios && (_jsxs(SettingsSection, __assign({ heading: "K\u00FChlware/BTM Priorisierung", description: "Auftr\u00E4ge die \u00FCber die Warenwirtschaft als K\u00FChlware/BTM\n                    markiert werden, erhalten einen h\u00F6here Priorit\u00E4t als\n                    Auftr\u00E4ge ohne diese Labels." }, { children: [_jsx(Switch, { checked: prioPosLabels, onChange: function (e) { return setPrioPosLables(e.target.checked); } }), _jsx(Paragraph, __assign({ marginLeft: 8 }, { children: prioPosLabels ? 'Aktiviert' : 'Deaktiviert' }))] }))), _jsx(SettingsSection, __assign({ heading: "Standard-Aufenthaltsdauer", description: " Die Standard-Aufenthaltsdauer f\u00FCr einen Fahrer bei einem\n                  Auftrage liegt voreingestellt bei 4 Minuten. Hier k\u00F6nnen sie\n                  diese Zeit individuell anpassen." }, { children: _jsx(DurationField, { step: 1, disabled: false, label: "Aufenthaltsdauer", value: processTime, onChange: setProcessTime }) })), _jsx(SettingsSection, __assign({ heading: "Maximale Fahrrad-Distanz", description: "Hier k\u00F6nnen sie die maximale Distanz festlegen, welche ein Fahrrad in einer Tour fahren darf." }, { children: _jsx(DurationField, { step: 1, disabled: false, suffix: "km", label: "Distanz (km)", value: bikeDistance, onChange: setBikeDistance }) })), includedPharmacies.includes(firebase.auth().currentUser.uid) ? (_jsx(SettingsSection, __assign({ heading: "Standorte bei Cure registrieren", description: "Hier kanns du deine Standorte bei Cure registieren, wenn du auf den Knopf klickst" }, { children: _jsx(Button, __assign({ isLoading: registerLoading, onClick: registerLocations }, { children: "Standorte jetzt registrieren" })) }))) : null, _jsx(SettingsSection, __assign({ heading: "Liefernachverfolgungs-Link f\u00FCr deine Apotheke", description: "Du kannst \u00FCber den Button deinen individuellen Liefernachverfolgungs-Link deiner Apotheke f\u00FCr deine Website, Social Media oder Marketing Aktivit\u00E4ten verfolgen. Damit k\u00F6nnen deinen Kunden mit ihren Auftragsnummer (Botendienstbelegnummer) und ihrer PLZ auch ohne E-Mail Adresse ihre Lieferung verfolgen" }, { children: userPlan === 'apomap-lite' ? (_jsx(UpgradeButton, {})) : (_jsx(Button, __assign({ onClick: handleTrackOrder }, { children: "Liefernachverfolgungs-Link" }))) })), (isUser === null || isUser === void 0 ? void 0 : isUser.shouldSeeGls) ? (_jsx(SettingsSection, __assign({ heading: "GLS Verbindung", description: "Du kannst \u00FCber den Button deinen GLS konto verbinden und activieren" }, { children: _jsxs(Pane, __assign({ display: "flex", gap: 12 }, { children: [_jsx(Button, __assign({ onClick: function () { return setIsGlsInput(function (prev) { return !prev; }); }, disabled: isGlsInput ? true : false }, { children: "GLS verbinden" })), isGlsInput && (_jsxs(Pane, { children: [_jsx(TextInput, { placeholder: "Gls Contact ID", value: glsContactId, onChange: function (e) { return setGlsContactId(e.target.value); } }), _jsx(Button, __assign({ onClick: handleGlsCredentials }, { children: "Aktivieren" }))] }))] })) }))) : null, includedPharmacies.includes(firebase.auth().currentUser.uid) ? (_jsx(SettingsSection, __assign({ heading: "MotionTools", description: "Sie k\u00F6nnen hier die MotionTools Api Key einf\u00FCgen, um Touren an externe Lieferdienstleister wie Cure zu \u00FCbermitteln" }, { children: userPlan === 'apomap-lite' ? (_jsx(UpgradeButton, {})) : (_jsx(_Fragment, { children: _jsxs(Pane, __assign({ display: "flex", flexDirection: "row", alignItems: "center" }, { children: [_jsx(TextInput, { value: motionToolsApiKey, type: showMotionToolsApiKey ? 'text' : 'password', placeholder: "MotionTools API Key einf\u00FCgen...", onChange: function (event) {
                                                        return setMotionToolsApiKey(event.target.value);
                                                    } }), _jsx(IconButton, { onMouseDown: function () { return setShowMotionToolsApiKey(true); }, onMouseUp: function () { return setShowMotionToolsApiKey(false); }, icon: EyeOpenIcon }), motionToolsApiKey !== '' && (_jsx(IconButton, { onClick: function () {
                                                        navigator.clipboard.writeText(motionToolsApiKey);
                                                        toaster.notify('Token kopiert!');
                                                    }, icon: ClipboardIcon })), _jsx(Button, __assign({ onClick: saveMotionToolsApiKey }, { children: "Speichern" }))] })) })) }))) : null] })), (isUser === null || isUser === void 0 ? void 0 : isUser.shouldSeeShopApotheke) ? (_jsx(SettingsSection, __assign({ heading: "ShopApotheke Integration" }, { children: userPlan === 'apomap-lite' ? (_jsxs(Pane, __assign({ style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '1rem',
                                } }, { children: [_jsxs(Pane, __assign({ style: {
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        } }, { children: [_jsx(Button, __assign({ disabled: true }, { children: "Setup ShopApotheke Integration" })), _jsx(Paragraph, __assign({ marginLeft: 8 }, { children: "im Plus oder Pro-Plan verf\u00FCgbar" }))] })), _jsx(Button, __assign({ size: "small", appearance: "primary", backgroundColor: '#2D3B51', onClick: function () { return (window.location.href = '/upgrade'); } }, { children: "Jetzt Upgraden" }))] }))) : (_jsx(Button, __assign({ onClick: function () { return setModal(true); } }, { children: "Verbinden Sie Ihren ShopApotheke" }))) }))) : null, _jsx(SettingsSection, __assign({ heading: "apomap Auftrags Relay", description: "Hier k\u00F6nnen sie die \u00DCbertragung von Auftr\u00E4gen auf ihren neuen apomap account aktivieren!" }, { children: _jsx(Relay, {}) })), modalShown && _jsx(ShopApothekeModal, {})] }))] })) })));
}
